module.exports = __webpack_public_path__ + "assets/img/warrior-name-21f5f9cc.png";